export const colors = {
  primary: "#616161",
  secondary: "#3a3a3a",
  background: "#272727",
  text: "#333",
  error: "#e74c3c",
  success: "#2ecc71",
  border: "#ddd"
};

export const fonts = {
  heading: "Arial, sans-serif",
  body: "Helvetica, sans-serif",
  code: "Courier New, monospace"
};

// You can add more reusable styles (e.g., spacing, borders, shadows, etc.)
export const spacing = {
  small: "8px",
  medium: "16px",
  large: "24px",
};

export const breakpoints = {
  mobile: "480px",
  tablet: "768px",
  desktop: "1024px"
};
